<!-- 手机验证 -->
<ng-container *ngIf="verifyType === 'PHONE'">
  <div class="form-group" *ngIf="!showAuthPropt">
    <label *ngIf="inputLabel">{{ inputLabel }}</label>
    <div
      class="input-group group-phone"
      [class.error]="!!authcode && authcode.length !== 6"
      [class.disabled]="submitLoading"
      [class]="size"
    >
      <app-customize-input
        [type]="'number'"
        [fixedHeight]="true"
        [loading]="isLoading"
        [width]="'100%'"
        [max]="6"
        #iAuthcode
        [(value)]="authcode"
        (onChange)="onAuthcodeInput(iAuthcode)"
        [disabled]="submitLoading"
        [placeholder]="phonePlaceHolder"
        [noBorder]="true"
      >
      </app-customize-input>
      <div
        class="input-group-txt get-code onact96-not"
        (click)="completePhoneNum(false)"
        *ngIf="authStatus !== 'sent' && !isLoading"
      >
        {{ authStatus !== 'timeout' ? ('get_verification_code_button' | translate) : ('resend' | translate) }}
      </div>
      <div class="input-group-txt has-send-code" *ngIf="authStatus === 'sent' && !isLoading">
        {{ 'resend' | translate }} ({{ timer }})
        <!-- {{ 'vercode_send' | translate }} -->
        <!-- <app-tool-tip>
          <i origin class="icon-warning mutual-opacity"></i>
          <div tooltip class="tooltip-info">
            <div class="tooltip-info-text">{{ 'no_rece' | translate }}{{ timer }}{{ 'resend_info' | translate }}</div>
          </div>
        </app-tool-tip> -->
      </div>
    </div>
    <!-- 输入框下面的错误信息 -->
    <div class="error-msg" *ngIf="!!authcode && authcode.length !== 6">
      {{ 'verification_error_msg' | translate }}
    </div>
    <div class="tips-msg" *ngIf="tips">
      {{ tips }}
    </div>
    <!-- 请输入您在手机 XXXXX 收到的6位验证码, 验证码30分钟有效 -->
    <p class="text-p" *ngIf="authStatus !== 'initial' && showTextP">
      {{ 'enter_phones' | translate }} {{ currentPhoneZone }} {{ phone }} {{ 'valid_time' | translate }}
    </p>
    <p class="none-p" *ngIf="authStatus !== 'initial'">
      <span class="link onact96-not" (click)="isShowPhoneTips = true">{{ 'null' | translate }}</span>
      <!-- <span>{{ 'sms_info' | translate }}</span> -->
      <!-- <span class="link onact96-not" (click)="completePhoneNum(true)">{{ 'null_t' | translate }}</span> -->
    </p>
    <div class="tips-for-code" *ngIf="isShowPhoneTips">
      <div class="tips-code-container">
        <i class="icon-error onact96-not" (click)="closeDialog()"></i>
        <div class="header">
          <i class="icon-left-arrow" (click)="isShowPhoneTips = false"></i> {{ 'phone_sms' | translate }}
        </div>
        <div class="text-first">{{ 'phone_sms_1' | translate }}：</div>
        <div class="group-text">
          <p>{{ 'phone_sms_2' | translate }}</p>
          <p>{{ 'phone_sms_3' | translate }}</p>
          <p>{{ 'phone_sms_4' | translate }}</p>
          <p>{{ 'phone_sms_5' | translate }}</p>
        </div>
        <customize-button width="100%" type="primary-linear" size="large-medium" (click)="isShowPhoneTips = false">
          {{ 'confirm_button' | translate }}
        </customize-button>
      </div>
    </div>
  </div>
  <!-- 补充 手机号码后6位事非弹窗 -->
  <ng-container *ngIf="showAuthPropt">
    <auth-prompt-page
      [currentPhoneZone]="currentPhoneZone"
      [phoneNum]="phone"
      (complete)="complete($event)"
    ></auth-prompt-page>
  </ng-container>
</ng-container>

<!-- google 验证 -->
<ng-container *ngIf="verifyType === 'GOOGLE'">
  <div class="form-group">
    <label *ngIf="inputLabel">{{ inputLabel }}</label>
    <div class="input-group group-phone">
      <app-customize-input
        #iGoogle
        [type]="'password'"
        [(value)]="googleCode"
        (onChange)="onGoogleInput(iGoogle)"
        [max]="6"
        [placeholder]="googlePlaceHolder"
        [autocomplete]="false"
      ></app-customize-input>
    </div>
    <div class="error-msg" *ngIf="!!googleCode && googleCode.length !== 6">
      {{ 'verification_error_msg' | translate }}
    </div>
  </div>
</ng-container>

<!-- 新增邮箱 验证码 -->
<ng-container *ngIf="verifyType === 'EMAIL'">
  <div class="form-group">
    <label *ngIf="inputLabel">{{ inputLabel }}</label>
    <div
      class="input-group group-phone"
      [class.error]="!!emailAuthCode && emailAuthCode.length !== 6"
      [class.disabled]="submitLoading"
    >
      <app-customize-input
        [type]="'number'"
        [fixedHeight]="true"
        [loading]="isLoading"
        [width]="'100%'"
        [max]="6"
        #iEmailAuthCode
        [(value)]="emailAuthCode"
        (onChange)="onEmailAuthcodeInput(iEmailAuthCode)"
        [disabled]="submitLoading"
        [placeholder]="emailPlaceHolder"
      ></app-customize-input>
      <div
        class="input-group-txt get-code onact96-not"
        [class.disabled]="!isFromSafeEmailValid"
        (click)="sendEmailAuthCode()"
        *ngIf="emailAuthStatus !== 'sent' && !isLoading"
      >
        {{ emailAuthStatus !== 'timeout' ? ('get_verification_code_button' | translate) : ('resend' | translate) }}
      </div>
      <div class="input-group-txt has-send-code" *ngIf="emailAuthStatus === 'sent' && !isLoading">
        {{ 'resend' | translate }} ({{ emailTimer }})
        <!-- {{ 'vercode_send' | translate }} -->
        <!-- <app-tool-tip>
          <i origin class="icon-warning mutual-opacity"></i>
          <div tooltip class="tooltip-info">
            <div class="tooltip-info-text">
              {{ 'no_rece' | translate }}{{ emailTimer }}{{ 'resend_info' | translate }}
            </div>
          </div>
        </app-tool-tip> -->
      </div>
    </div>
    <div class="error-msg" *ngIf="!!emailAuthCode && emailAuthCode.length !== 6">
      {{ 'verification_error_msg' | translate }}
    </div>
    <div class="tips-msg" *ngIf="tips">
      {{ tips }}
    </div>
    <ng-container *ngIf="otpType === 'Login' || otpType === 'Register' || otpType === 'ResetPwd'">
      <p class="none-p" *ngIf="emailAuthStatus !== 'initial'">
        <span class="link onact96-not" (click)="isShowEmailTips = true">{{ 'null' | translate }}</span>
      </p>
    </ng-container>
  </div>
  <div class="tips-for-code" *ngIf="isShowEmailTips">
    <div class="tips-code-container">
      <i class="icon-error onact96-not" (click)="closeDialog()"></i>
      <div class="header">
        <i class="icon-left-arrow" (click)="isShowEmailTips = false"></i> {{ 'email_ver_code_no_receive' | translate }}
      </div>
      <div class="text-first">{{ 'email_ver_code_no_receive_1' | translate }}</div>
      <div class="group-text">
        <p>{{ 'email_ver_code_no_receive_2' | translate }}</p>
        <p>{{ 'email_ver_code_no_receive_3' | translate }} {{ email }}。</p>
        <p>{{ 'email_ver_code_no_receive_4' | translate }}</p>
      </div>
      <customize-button width="100%" type="primary-linear" size="large-medium" (click)="isShowEmailTips = false">
        {{ 'confirm_button' | translate }}
      </customize-button>
    </div>
  </div>
</ng-container>
